import { BtnAnch } from 'components/elements/global'
import MAudio from 'components/elements/Mcomponents/MAudio'
import { FC, useState } from 'react'
import useCallRecording from '../hooks/useCallRecording'
import { TCall } from '../types'

const CallRecordingCell: FC<{ call: TCall; leadId?: any }> = ({
 call,
 leadId,
}) => {
 const [started, setStarted] = useState(false)
 const recording = useCallRecording()

 if (!call.has_recording) {
  return <span className="text-muted">--</span>
 }

 if (!started) {
  return (
   <BtnAnch
    className="colored-link-1"
    onClick={() => {
     setStarted(true)
     recording.load(
      leadId
       ? `user/leads/${leadId}/calls/${call.id}/recording`
       : `user/calls/${call.id}/recording`,
     )
    }}
   >
    <i className="fas fa-play-circle me-1" />
    Play
   </BtnAnch>
  )
 }

 if (recording.error) {
  return <span className="text-danger">{recording.error}</span>
 }

 return (
  <MAudio
   src={recording.src ?? ''}
   loading={recording.loading || !recording.src}
   autoPlay
  />
 )
}

export default CallRecordingCell
